"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Array_1 = require("fp-ts/lib/Array");
const E = require("fp-ts/lib/Either");
const _1 = require(".");
function arrayV(path, itemValidator) {
    return (ts) => Array_1.array.sequence(_1.AP)(ts.map((t, i) => itemValidator([...path, `${i}`])(t)));
}
exports.arrayV = arrayV;
function arrayMinLength(path, minLength) {
    return (value) => {
        if (value === undefined || value.length < minLength) {
            return E.left([
                new _1.ValidationError(path, `must contain at least ${minLength} entries`, new ArrayMinLengthInfo(minLength)),
            ]);
        }
        return E.right(value);
    };
}
exports.arrayMinLength = arrayMinLength;
class ArrayMinLengthInfo {
    constructor(minLength) {
        this.minLength = minLength;
        this.type = 'arrayMinLength';
    }
}
// nonEmptyArray is semantically same as arrayMinLength with minLength of 1.
// However, this special case exists here explicitly as it makes some use cases simpler,
// e.g. displaying more user friendly error messages in UI
function nonEmptyArray(path) {
    return (value) => {
        if (value === undefined || value.length === 0) {
            return E.left([
                new _1.ValidationError(path, 'must not be empty', new NonEmptyArrayInfo()),
            ]);
        }
        return E.right(value);
    };
}
exports.nonEmptyArray = nonEmptyArray;
class NonEmptyArrayInfo {
    constructor() {
        this.type = 'nonEmptyArray';
    }
}
